import is from 'ramda/src/is';

import camelCase from './camelCase';

const isObject = value => is(Object, value) && !Array.isArray(value);

const mapDataToCamelCase = inputData =>
    Object.keys(inputData)
        .reduce((outputData, next) => {
            const key = camelCase(next);
            let value = inputData[next];
            if (Array.isArray(value)) {
                value = value.map(child => (isObject(child) ? mapDataToCamelCase(child) : child));
            } else if (isObject(value)) {
                value = mapDataToCamelCase(value);
            }
            outputData[key] = value;
            return outputData;
        }, {});

export default mapDataToCamelCase;
